var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"cb-button cb-button--blue",class:{
    className: _vm.className,
    'cb-button--loading': _vm.loading,
    'cb-button--padding-left': _vm.paddingLeft,
  },attrs:{"type":_vm.type,"disabled":_vm.disabled || _vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[_c('div',{staticClass:"cb-button__spinner"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('cb-spinner',{attrs:{"size":"small"}}):_vm._e()],1)],1),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }